var map = {
	"./AboutView.vue": [
		"d7a9",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"about-view"
	],
	"./BibliographyView.vue": [
		"05b6",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"bibliography-view~works-view",
		"bibliography-view"
	],
	"./BiographyView.vue": [
		"4053",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"biography-view"
	],
	"./HomeView.vue": [
		"7d97",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"home-view"
	],
	"./LocaleView.vue": [
		"76d5",
		"locale-view"
	],
	"./NoPageView.vue": [
		"799c",
		"no-page-view"
	],
	"./PricesView.vue": [
		"acc5",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"prices-view"
	],
	"./WorkView.vue": [
		"2abd",
		"work-view"
	],
	"./WorksView.vue": [
		"ac8a",
		"about-view~bibliography-view~biography-view~home-view~prices-view~works-view",
		"bibliography-view~works-view",
		"works-view"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;